(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionOptionController', QuestionOptionController);

    QuestionOptionController.$inject = ['$scope', '$state', 'QuestionOption', 'QuestionOptionSearch'];

    function QuestionOptionController ($scope, $state, QuestionOption, QuestionOptionSearch) {
        var vm = this;
        vm.questionOptions = [];
        vm.loadAll = function() {
            QuestionOption.query(function(result) {
                vm.questionOptions = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            QuestionOptionSearch.query({query: vm.searchQuery}, function(result) {
                vm.questionOptions = result;
            });
        };
        vm.loadAll();
        
    }
})();
